import React from "react";
import { useIntl } from "react-intl";

const Contact = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <h1>{formatMessage({ id: "contato" })}</h1>

      <div className="content-box results">
        <h3>Terras App Solutions</h3>
        <p>
          <span className="bold">{formatMessage({ id: "endereco" })}:</span> Rua
          Antônio Barreto, 130, Edifício Village Office, sala 1508 - Umarizal -
          Belém - Pará - Brasil - 66055-050
        </p>
        <p>
          <span className="bold">{formatMessage({ id: "fone" })}:</span>{" "}
          <s>+55 (91) 3204-2940</s>{" "}
          {formatMessage({ id: "mensagem-home-office-telefone" })} +55 (91)
          99379-7701
        </p>
        <p>
          <span className="bold">E-mail:</span> suporte@terras.zendesk.com
        </p>
        <p>
          <span className="bold">WhatsApp:</span>{" "}
          <a
            href="https://api.whatsapp.com/send?phone=5591993797701"
            target="_blank"
            rel="noopener noreferrer"
          >
            +55 (91) 99379-7701
          </a>
        </p>
        <p>
          <span className="bold">
            {formatMessage({ id: "horario-atendimento" })}:
          </span>{" "}
          {formatMessage(
            { id: "horario-atendimento-descricao" },
            { de: "8h", ate: "17h" }
          )}
        </p>
      </div>
    </>
  );
};

export default Contact;
